import { number, object } from "prop-types";
import { observer } from "mobx-react";
import { useFeatureGuardian } from "@hooks";
import { LOCKED_FEATURES } from "@utils";
import { PinnableCell, SummaryRow } from "@tools";
import { AddButtonFull } from "@components";
import { useTranslation } from "react-i18next";
import { TimelineFiller } from "@tools/EstimateEditor/components/Tables/TableTimeline/components";

export const TimelineNewChildRow = observer(({
  workType,
  tableDepth,
}) => {
  const { t } = useTranslation();
  const { checkAccess, FeatureAlert } = useFeatureGuardian(
    LOCKED_FEATURES.ALLOCATION
  );
  
  const handleNewResource = async () => {
    const allowed = await checkAccess();
    if (!allowed) return;
    workType.addResource(true, `r${new Date().getTime()}`, true);
  };
  
  return (
    <SummaryRow isLastGroupRow tableDepth={tableDepth}>
      <FeatureAlert />
      <PinnableCell
        allowOverflowDisplay
        pinnedLeft
        hasStaticWidth
        innerStyle={{ paddingLeft: "var(--create-padding-1)" }}
      >
        <AddButtonFull
          id="newTeamMemberButton-timeline"
          onClick={handleNewResource}
          name="Add new resource to work type"
        >
          {t("views.editor.summary_table.work_resource_add")}
        </AddButtonFull>
      </PinnableCell>
      <TimelineFiller totalDevelopmentTime={0} />
    </SummaryRow>
  )
})

TimelineNewChildRow.propTypes = {
  workType: object.isRequired,
  tableDepth: number.isRequired,
}